import React, { useState } from 'react';

import ContactSelector from 'bundles/backoffice/contacts/selector';
import ManagedInput from 'components/form/managed_input';

import type { Contact } from 'bundles/backoffice/contacts/types';
import type { ContactSelectorProps } from './types';

interface Props extends ContactSelectorProps {
  contact: Contact;
  employer?: Contact | null;
  onChange: (employer: Contact | null) => void;
}

export function EmployerInput({
  allowTagging, contact, employer, newContactVisibility, requestPermissions, onChange
}: Props) {
  const [searchForEmployer, setSearchForEmployer] = useState(!contact.businessRecords?.length);

  let input: React.ReactNode;
  if (searchForEmployer) {
    input = (
      <ContactSelector
        allowTagging={allowTagging}
        autoFocus
        contact={employer}
        contactType="business"
        modalBackdrop={false}
        newContactVisibility={newContactVisibility}
        requestPermissions={requestPermissions}
        onChange={onChange}
      />
    );
  } else {
    const businesses = contact.businessRecords?.map(record => record.business) ?? [];

    input = (
      <ManagedInput
        getOptionValue={business => business.id}
        isClearable
        options={[...businesses, { id: 'search', label: 'Search for others...' }]}
        type="combobox"
        value={employer}
        onValueChange={(option) => {
          onChange(businesses.find(business => business.id === option?.id) || null);
          setSearchForEmployer(option?.id === 'search');
        }}
      />
    );
  }

  return (
    <div className="form-group">
      <label className="form-label">Company</label>
      {input}
    </div>
  );
}
